import { Component, Input, OnInit, OnDestroy } from '@angular/core';
import { TourService, TourStep } from '../../services/tour.service';
import { TourConfigService } from '../../services/tour-config.service';
import { DynamicTourService } from '../../services/dynamic-tour.service';
import { UserSettingsService } from '../../services/user-settings.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../stores/states/app.state';
import * as UserActions from '../../stores/actions/user.actions';

@Component({
  selector: 'app-tour-notification',
  templateUrl: './tour-notification.component.html',
  styleUrls: ['./tour-notification.component.scss']
})
export class TourNotificationComponent implements OnInit, OnDestroy {
  @Input() tourSteps: TourStep[] = [];
  @Input() currentUser: any = null;
  @Input() notificationTitle: string = 'News Feed Tour';
  @Input() notificationIcon: string = 'rss';
  @Input() notificationMessage: string = 'Want to learn more about the features? Start a quick tour to explore the interface.';
  @Input() notificationDescription: string = 'Discover how to navigate the dashboard, manage boards, and use AI-powered features to summarize content, answer questions, and explore information.';
  @Input() notificationId: string = 'default-tour-notification';
  @Input() showResetOption: boolean = true;

  isVisible = true;
  isExpanded = true;
  isPermanentlyHidden = false;
  private autoHideTimeout?: number;

  constructor(
    private tourService: TourService,
    private tourConfigService: TourConfigService,
    private dynamicTourService: DynamicTourService,
    private userSettingsService: UserSettingsService,
    private store: Store<AppState>
  ) { }

  ngOnInit(): void {
    this.isPermanentlyHidden = localStorage.getItem(`${this.notificationId}-hidden`) === 'true';
  }

  ngOnDestroy(): void {
    if (this.autoHideTimeout) {
      clearTimeout(this.autoHideTimeout);
      this.autoHideTimeout = undefined;
    }
  }

  toggleExpanded(): void {
    this.isExpanded = !this.isExpanded;
  }

  hideNotification(): void {

    this.isVisible = false;
  }

  hideNotificationPermanently(event?: Event): void {

    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    this.isPermanentlyHidden = true;
    this.isVisible = false;
    localStorage.setItem(`${this.notificationId}-hidden`, 'true');

  }

  showNotification(): void {

    this.isPermanentlyHidden = false;
    this.isVisible = true;
    localStorage.removeItem(`${this.notificationId}-hidden`);

  }

  startTour(): void {


    if (this.tourSteps.length > 0) {

      this.tourService.initTour(this.tourSteps);
      this.tourService.start();
    } else {

      const tourSteps = this.tourConfigService.getDashboardTourSteps();
      this.tourService.initTour(tourSteps);
      this.tourService.start();
    }
    this.hideNotification();
  }


  hasSeenTour(): boolean {
    return this.currentUser?.settings?.showTourOnFirstVisit === false;
  }


  async resetTourSetting(): Promise<void> {
    try {

      const userSettings = this.currentUser?.settings || {};
      await this.userSettingsService.save({
        ...userSettings,
        showTourOnFirstVisit: true,
      });


      this.store.dispatch(UserActions.updateUserSettings({
        settings: { ...userSettings, showTourOnFirstVisit: true }
      }));

      this.currentUser = {
        ...this.currentUser,
        settings: { ...userSettings, showTourOnFirstVisit: true }
      };
    } catch (error) {
      console.error('Error resetting tour setting:', error);
    }
  }


  getNotificationStatus(): any {
    return {
      isPermanentlyHidden: this.isPermanentlyHidden,
      isVisible: this.isVisible,
      notificationId: this.notificationId,
      localStorageValue: localStorage.getItem(`${this.notificationId}-hidden`),
      userSettings: this.currentUser?.settings?.showTourOnFirstVisit
    };
  }


  clearNotificationHidden(): void {

    localStorage.removeItem(`${this.notificationId}-hidden`);
    this.isPermanentlyHidden = false;
    this.isVisible = true;

  }
}
